module.exports = __webpack_public_path__ + "img/marker_two_cyan3.876f9877.png";